import Table from '../Table/index'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faCheck } from '@fortawesome/pro-regular-svg-icons'
import { faMoneyCheckEdit  } from '@fortawesome/pro-solid-svg-icons'
import { Dispatch, SubmitButton } from '../architecture/frontend/index'
import { filter } from 'rxjs/operators'
import _ from 'lodash'
import loadingSVG from '../../media/loading.svg'
import Select from 'react-select'

import {useState} from 'react'

const columnLayout = [
  {
    field: 'checkbox',
    header: '',
    type: 'checkbox',
    width: '40px',
    fieldStyle: 'justify-center'
  },
  {
    field: 'companyUuid',
    header: 'Id',
    type: 'id',
    style: 'ph2',
    fieldStyle: 'ph2'
  },
  {
    field: 'shipmentId',
    header: 'Shipment Id',
    type: 'text',
    style: 'ph2',
    fieldStyle: 'ph2'
  },
  {
    field: 'claimId',
    header: 'Claim Id',
    type: 'text',
    style: 'ph2',
    fieldStyle: 'ph2'
  },
  {
    field: 'claimedDate',
    header: 'Claimed',
    type: 'date',
    style: 'tc',
    fieldStyle: 'justify-center',
  },
  {
    field: 'claimMoisturePercent',
    header: 'M',
    type: 'text',
    groupHeader: 'Claim 12%',
    style: 'bg-light-yellow tc',
    fieldStyle: 'tc',
  },
  {
    field: 'claimProtein12Percent',
    header: 'P',
    type: 'text',
    groupHeader: 'Claim 12%',
    style: 'bg-light-yellow tc',
    fieldStyle: 'tc',
  },
  {
    field: 'claimFiber12Percent',
    header: 'F',
    type: 'text',
    groupHeader: 'Claim 12%',
    style: 'bg-light-yellow tc',
    fieldStyle: 'tc',
  },
  {
    field: 'shipmentInvoiceAmount',
    header: 'Invoice $',
    type: 'text',
    groupHeader: '',
    style: 'tc',
    fieldStyle: 'tc',
  },
]

const TableSet = (props) => {
  const customerCode = props._customer?.code
  const customerName = props._customer?.name
  const originName = props._origin?.name
  const originCode = props._origin?.code
  const originId = props._origin?.id
  const tableName = 'tableName-' + customerCode + '-' + originCode
  const data = _.filter(props.shipments?.rawData, shipment => shipment.customer?.code === customerCode && shipment.origin?.code === originCode )

  const [lab, setLab] = useState(null)
  const labName = _.find(props.locations?.rawData, location => location.id === lab)?.name
  const disabledClass = lab ? ' ' : ' o-50 '
  const disabledStyle = lab ? {} : {pointerEvents: 'none'}
  const userEmail = props.user.email
  return (
    <div className='mt3 pa2 w-100 ba b--moon-gray br3' style={{background: '#f5f3f5'}}>
      <div className='ph3 pt1  w-100 flex justify-between items-end'>
        <div className='pl1 pt1 f6 fw5 dark-gray'>
          <div className='flex'>
            <div>
              <div className='tr'>Customer: </div>
              <div className='tr pt1'>Origin: </div>
              <div className='tr pt3'>Lab: </div>
            </div>
            <div className='pl3'>
              <div className=''>{customerCode} - {customerName}</div>
              <div className='mt1'>{originCode} - {originName} </div>
              <Select id={'labSelect' + customerCode + '-' + originCode} className='pt2 w5' options={_.filter(props.locations?.rawData, location => location.type==='LAB')?.map(type => ({value: type.id, label: type.code + ' - ' + type.name})) ?? [] } onChange={e => setLab(e.value)} />
            </div>
          </div>
        </div>
        <div className='flex'>
          <div className={'mh1 mb2 pv2 ph3 br2 white f6 flex pointer ' + disabledClass} style={{background: '#6ba686', ...disabledStyle}}
            onClick={e => Dispatch.nextAction('__.Modal.open', {
              type: 'email', 
              details: {
                title: "Send Claims Refereed Notice",
                description: "Use the following form to send a claim referee notice to the customer.",
                onClick: (e, args) => Dispatch.nextAction('__.Modal.open', {
                  type: 'email',
                  details: {
                    key: '2xxxxxxxxxxxxxxx',
                    title: "Send Refereed Notice To Lab",
                    description: "Use the following form to send a claim referee notice to the lab.",
                    tableName: tableName, 
                    onClick: (e, args2) => Dispatch.nextAction('shipments.sendToReferee', {
                      tableName: tableName, 
                      lab, 
                      sendEmail: true, 
                      labToAddress: args2.toAddress,
                      labMessage: args2.message,
                      customerToAddress: args.toAddress, 
                      customerMessage: args.message
                    }),
                    request: 'sendRefereeShipments',
                    dataType: 'sendReferee',
                    defaultEmail: _.find(props.locations?.rawData, location => location.id === originId)?.email,
                    defaultMessage: 'Enclosed are samples we wish to have refereed. Please do analysis for Protein & Fiber for the following shipments and forward to ' + labName + ' in the form of an email. Hard copies are not necessary. Please be sure to indicate which facility the sample originated. Thank you.',
                    lab,
                    emailCC: userEmail
                  },
                }),
                request: 'sendRefereeShipments',
                dataType: 'sendReferee',
                defaultEmail: props._customer?.email,
                defaultMessage: 'The following claims have been sent to referee:',
                proceedText: 'Next Step',
                lab,
                emailCC: userEmail
              }
            })}
          > <FontAwesomeIcon className='pr2 f6 white' icon={faEdit} /> Email </div>
            


          <SubmitButton className='' 
            defaultChild={ props => (
                <div 
                className={'mh1 mb2 pv2 ph3 br2 white f6 flex pointer ' + disabledClass} 
                style={{background: '#6ba686', ...disabledStyle}}
                onClick= {e => Dispatch.nextAction('shipments.sendToReferee', { tableName: tableName, lab, sendEmail: false, toAddress: null, message: null})}> 
                  <FontAwesomeIcon className='pr2 f6 white' icon={faCheck} /> 
                  Mark as Sent 
              </div>
            )}
            loadingChild={ props => (
                <div className='mh3 ' style={{width:40, height: 30}}>
                  <img className='w-100 h-100' src={loadingSVG} alt='loading'/>
                </div>
            )}
            errorChild={ props => (
              <div className='pl3 f7 fw4 red tr pointer'>Error</div>
            )}
            loadingStream={
              Dispatch.getAction('Request.sendRefereeShipments')
                .pipe(
                )
              }
            successStream={
              Dispatch.getAction('Response.sendRefereeShipments')
                .pipe(
                  filter(e => _.isNil(e.errors) && ((!_.isNil(e.data.sendReferee) || !_.isNil(e.data.sendReferee) ))),
                )
              }
            errorStream={
              Dispatch.getAction('Response.sendRefereeShipments')
                .pipe(
                  filter(e => !_.isNil(e.errors)),
                )}
          />
        </div>
      </div>
      <div className='pt3 w-100 flex' style={{background: '#f5f3f5'}}>
        <Table _tableName={tableName} _shipments={data}  _columnLayout={columnLayout} {...props}/>
      </div>
    </div>
  )
}

const AllSamples = (props) => {
  const unique = !props.shipments?.loading ? _.uniqBy(props.shipments?.rawData, shipment => { return shipment.origin?.id + '-' + shipment.customer?.id }) : 'loading'
  return (
    <div className='w-100 ph3 overflow-y-auto' style={{maxHeight: props.ui?.window?.height - props.ui?.window?.header - 5}}>
      <div className='w-100 pa2 ph3 flex items-center justify-between bg-evonik-purple' style={{position:'sticky', top:0, zIndex:5000}} >
        <div className='flex items-center'>
          <FontAwesomeIcon className='relative f5 white' icon={faMoneyCheckEdit} style={{top:-3}} />
          <div className='pl2 fw7 f6 white'>Claims Pending Referee Submittal </div>
          <div className='h2'></div>
        </div>
        <div className='flex'>
        </div>
      </div>
      {unique === 'loading' ? 
        <div className='h5 w-100 flex justify-center'>
          <img className='w4' src={loadingSVG} alt='loading'></img>
        </div>
        :
        unique.length > 0 ? unique.map(uni => {
          return (
            <TableSet key={uni.customer?.id + '-' + uni.origin?.id} _customer={uni.customer} _origin={uni.origin} {...props} />
          )
        })
        :
        <div className='w-100 pt4 flex justify-center'>
          <div class='f5'>No Data To Display</div>
        </div>
      }
    </div>
  )
}

export default AllSamples